import Sidebar from "../sidebar/sidebar.index";
import { Outlet, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { layoutProps } from "./layout.interface";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { setInputUrl } from "../../../redux/slices/newLoginSlice";
import { Suspense, lazy, useEffect, useRef, useState } from "react";
import PATH from "../../../urls/path";
import Guide from "../../../utils/component/app-tour/appTour.index";
import { iOSDetection, isTouchScreen } from "../../../scripts/helpers";
import { setMobileSidebarStatus } from "../../../redux/slices/layoutSlice";
import { ReactComponent as AbreHamrahi } from "../../../assets/images/svg/logoIcon.svg";
import { ReactComponent as Times } from "../../../assets/images/sidebar/Times.svg";
import { ReactComponent as BottomAndroid } from "../../../assets/images/svg/android.svg";
import { ReactComponent as TopAndroid } from "../../../assets/images/svg/android-top.svg";
import { get, responseValidator } from "../../../scripts/api";
import API from "../../../urls/api";
import WarningPlanDialog from "../../../utils/component/warningPlanDialog/warningPlanDialog.index";
import { ENVIRONMENT } from "../../../environment";
import { shallowEqual } from "react-redux";
import Header from "../header/header.index";

const PublicFolderHeader = lazy(() => import("../publicFolderHeader/header.index"));

export default function Layout(props: layoutProps): JSX.Element {
    const { authStatus } = useAppSelector(({ auth: { authStatus } }) => ({ authStatus }), shallowEqual);
    const { newLogin } = useAppSelector(({ newLogin: { newLogin } }) => ({ newLogin }), shallowEqual);
    const { mobileSidebarStatus } = useAppSelector(({ layout: { mobileSidebarStatus } }) => ({ mobileSidebarStatus }), shallowEqual);
    const [searchParams] = useSearchParams();
    const [guides, setGuides] = useState<any>(null);
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useAppDispatch();
    const guideRef = useRef();
    const refGuides = useRef<any>(guides);
    const [link, setLink] = useState<string>("");
    const [showDownloadLink, setShowDownloadLink] = useState<boolean>(false);
    const androidWebView = searchParams.get(ENVIRONMENT.android) === "true";

    useEffect(() => {
        refGuides.current = guides;
    }, [guides]);

    useEffect(() => {
        if (newLogin && authStatus === "VALID") {
            dispatch(setInputUrl(location.pathname + location.search));
            navigate(PATH.dashboard);
            if (isTouchScreen())
                setTimeout(() => {
                    dispatch(setMobileSidebarStatus(true));
                    setGuides(<Guide ref={guideRef} />);
                }, 1000);
            else setGuides(<Guide ref={guideRef} />);
        }
    }, [mobileSidebarStatus, newLogin]);

    useEffect(() => {
        if (!sessionStorage.getItem("DOWNLOAD_MOBILE_VERSION") && !iOSDetection() && isTouchScreen()) {
            get((data, status) => {
                if (responseValidator(status)) {
                    const android = data.find((item: any) => item.device === "android");
                    setLink(android.download_links[0].url);
                    setShowDownloadLink(true);
                }
            }, API.landing.download());
        }
    }, []);

    return (
        <div id="layout" className="w-full h-screen mx-auto px-4 pt-4 pb-0 sm:pt-4 sm:pb-4 gap-4 flex">
            <WarningPlanDialog />
            {refGuides.current}
            {!androidWebView && showDownloadLink && link && (
                <div className="fixed bottom-0 right-0 w-full h-[95px] bg-primary-100 z-[100] rounded-t-[10px]">
                    <div className="flex relative justify-between items-center w-full h-full px-5">
                        <div className="absolute bottom-0 left-32 z-[1]">
                            <BottomAndroid />
                        </div>
                        <div className="absolute top-0 left-12 z-[1]">
                            <TopAndroid />
                        </div>
                        <a href={link} className="relative flex items-center gap-2 cursor-pointer z-[10]">
                            <AbreHamrahi />
                            <div className="font-medium text-[16px]">{`دریافت اپلیکیشن اندروید ${ENVIRONMENT.brandName}`}</div>
                        </a>
                        <div
                            className="relative cursor-pointer z-[10]"
                            onClick={() => {
                                sessionStorage.setItem("DOWNLOAD_MOBILE_VERSION", String(true));
                                setShowDownloadLink(false);
                            }}
                        >
                            <Times />
                        </div>
                    </div>
                </div>
            )}
            {props.general ? <Sidebar /> : <></>}
            <div className="w-full h-full overflow-hidden flex flex-col">
                {props.general ? (
                    androidWebView && isTouchScreen() ? null : (
                        <Header />
                    )
                ) : (
                    <Suspense>
                        <PublicFolderHeader />
                    </Suspense>
                )}
                <div onScroll={(e) => {}} className="overflow-auto h-full sm:rounded-[10px] sm:bg-white" id="content">
                    <Outlet />
                </div>
            </div>
        </div>
    );
}
